<template>
  <v-container>
    <!---------desktop menu-------------->
    <!-- <v-app-bar elevation="0" color="transparent" class="d-none d-sm-block"> -->
    <div id="desktop-nav" class="d-none d-sm-flex justify-space-between align-center">
      <logo />
      <!-- v-spacer to push content to ends of the container--->
      <v-spacer></v-spacer>
      <div class="">
        <router-link :to="{ name: 'home' }" class=""> Home </router-link>
        <router-link :to="{ name: 'contact' }"> Contact </router-link
        ><router-link to="" v-fidia="{ name: 'opeolluwa', slug: 'edwork' }">
          Support
        </router-link>
        <router-link :to="{ name: 'login' }" class="login-button">
          login
        </router-link>
      </div>
    </div>
    <!-- </v-app-bar> -->
    <!------------application entry------------->
    <transition
      mode="out-in"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
    >
      <router-view></router-view>
    </transition>
    <!-------------footer-------------->
    <base-footer class="d-non"></base-footer>
    <!--------------mobile option-------->
    <v-speed-dial bottom right v-model="fab" class="d-sm-none d-none" fixed>
      <template v-slot:activator>
        <v-btn v-model="fab" color="var(--black)" elevation="10" fab>
          <v-icon v-if="fab" color="var(--white)"> mdi-close </v-icon>
          <v-icon v-else color="var(--white)"> mdi-menu </v-icon>
        </v-btn>
      </template>
      <!-----fab options home------------>
      <v-btn fab :to="{ name: 'home' }" small color="var(--white)">
        <v-icon> mdi-home-variant-outline </v-icon>
      </v-btn>
      <!-----fab options contact------------>
      <v-btn fab :to="{ name: 'login' }" small color="var(--white)">
        <v-icon> mdi-account-outline </v-icon>
      </v-btn>
      <!-----fab options contact------------>
      <v-btn fab :to="{ name: 'contact' }" small color="var(--white)">
        <v-icon> mdi-email-fast-outline </v-icon>
      </v-btn>
    </v-speed-dial>
  </v-container>
</template>

<script>
import BaseFooter from "@/components/AppFooter.vue";
import Logo from "@/components/AppLogo.vue";
import "./fidia-vue";
export default {
  components: {
    BaseFooter,
    Logo,
  },

  data: () => ({
    fab: false,
  }),
};
</script>


<style scoped lang="scss">
.v-btn-floating {
  position: relative;
}
#desktop-nav {
  a {
    color: var(--black);
    font-weight: 400;
    font-size: larger;
    line-height: 36px;
    text-decoration: none;
    margin: 0 10px;
  }

  .login-button {
    border: 1px solid var(--black);
    padding: 5px 7.5px;
    border-radius: 5px;
    color: var(--white);
    background: var(--black);
  }
}
</style>
